import { WorkflowObject } from '@varos/interview-sdk';
import { WorkflowEntity } from '@varos/interview-react';

export function toWorkflowEntity(dto: WorkflowObject): WorkflowEntity {
    return dto;
}
